export default {
	task_add_activity_to_existing: 'Add to existing task',
	task_alarm: 'Alarm',
	task_alarm_active: 'Alarm',
	task_alarm_active_activated: 'active',
	task_alarm_active_deactivated: 'inactive',
	task_alarm_date_and_time_label: 'Date and time',
	task_alarm_owner_type_label: 'Creator',
	task_alarm_owner_type_option_always: 'always',
	task_alarm_owner_type_option_never: 'never',
	task_alarm_owner_type_option_onlyOnUnfinished: 'only on unfinished',
	task_alarm_user: 'Users',
	task_create_from_activity: 'Create new task from activity',
	task_create_from_activity_error: 'The task could not be created.',
	task_created_for_label: 'Created for',
	task_datefield_close: 'Close',
	task_delete_dialog_confirm_cancel_label: 'No',
	task_delete_dialog_confirm_message: 'Do you really want to delete this task?',
	task_delete_dialog_confirm_ok_label: 'Yes',
	task_delete_dialog_confirm_title: 'Delete task',
	task_fixed_description_label: 'Description',
	task_fixed_maturity_date_label: 'Due date',
	task_link_activity_error_already_linked: 'The activity is already linked to this task.',
	task_link_activity_error_conflict: 'The task changed in the meantime. Please try again.',
	task_link_activity_error_forbidden: 'You may not link this activity to the task.',
	task_link_activity_error_invalid_origin: 'The activity cannot be linked.',
	task_link_activity_error_invalid_url: 'The URL cannot be linked to the task.',
	task_link_activity_error_task_locked: 'The task is currently locked.',
	task_link_activity_error_task_not_open: 'The selected task is no longer open.',
	task_link_activity_error_transport_error: 'The link could not be saved.',
	task_link_activity_error_validation_failed: 'The link could not be validated.',
	task_link_activity_url_cancel: 'Cancel',
	task_link_activity_url_context_action: 'Add activity via URL',
	task_link_activity_url_dialog_title: 'Link activity via URL',
	task_link_activity_url_label: 'Internal activity URL',
	task_link_activity_url_placeholder: 'Paste an activity URL',
	task_link_activity_url_refresh_error: 'The activity was linked, but the task could not be refreshed.',
	task_link_activity_url_submit: 'Add',
	task_link_activity_url_success: 'The activity was linked to the task.',
	task_linked_activities: 'Linked activities',
	task_linked_activities_drop_empty: 'Drop activities here to link them with the task.',
	task_linked_activities_empty: 'No linked activities',
	task_linked_activity: 'Linked activity',
	task_linked_activity_contact: 'Contact',
	task_linked_activity_date: 'Date',
	task_linked_activity_date_time: 'Date/time',
	task_linked_activity_duplicate: 'This activity is already linked.',
	task_linked_activity_information: 'Information',
	task_linked_activity_open: 'Open activity',
	task_linked_activity_remove: 'Remove link',
	task_linked_activity_remove_confirm_cancel_label: 'No',
	task_linked_activity_remove_confirm_message: 'Do you really want to remove this link?',
	task_linked_activity_remove_confirm_ok_label: 'Yes',
	task_linked_activity_remove_confirm_title: 'Remove link',
	task_linked_activity_remove_error_task_locked: 'The task is currently locked.',
	task_linked_activity_remove_error_task_not_open: 'The task is no longer open.',
	task_linked_activity_remove_error_transport_error: 'The link could not be removed.',
	task_linked_activity_remove_refresh_error: 'The link was removed, but the task could not be refreshed.',
	task_linked_activity_remove_success: 'The link was removed.',
	task_linked_activity_type: 'Type',
	task_linked_activity_unavailable: 'Unavailable or deleted',
	task_linked_activity_unknown_module: 'Unknown activity',
	task_linked_activity_unsupported: 'This activity type cannot be linked.',
	task_linked_tasks_open_aria_label: 'Open task “{title}”',
	task_linked_tasks_task_label: 'Task',
	task_linked_tasks_title: 'Linked tasks',
	task_next_week: 'Schedule next week',
	task_next_week_notification: 'Task scheduled for next week',
	task_open_picker_cancel: 'Cancel',
	task_open_picker_close: 'Close',
	task_open_picker_empty: 'No open tasks found.',
	task_open_picker_error: 'The open tasks could not be loaded.',
	task_open_picker_filtered_empty: 'No open tasks match the search.',
	task_open_picker_linked_confirmation: 'Activity added to the task.',
	task_open_picker_linked_status: 'Added',
	task_open_picker_loading: 'Loading open tasks…',
	task_open_picker_search: 'Search open tasks',
	task_open_picker_submit: 'Add',
	task_open_picker_title: 'Add to existing task',
	task_repetition_active: 'Repetition',
	task_repetition_count_end_label: 'Number of repetitions',
	task_repetition_delete_scope_all: 'including all subsequent repeating tasks',
	task_repetition_delete_scope_message: 'Which tasks should be deleted?',
	task_repetition_delete_scope_single: 'Only this task',
	task_repetition_delete_scope_title: 'Delete task',
	task_repetition_end_date_label: 'End date',
	task_repetition_end_option_by_number: 'by number',
	task_repetition_end_option_never: 'never (until 2038)',
	task_repetition_end_option_on_fixed_date: 'on a fixed date',
	task_repetition_ends: 'ends',
	task_repetition_interval: 'interval',
	task_repetition_monthly_rule_by_day: 'day',
	task_repetition_monthly_rule_by_weekday: 'by weekday',
	task_repetition_monthly_rule_label: 'monthly rule',
	task_repetition_off: 'disabled',
	task_repetition_on: 'enabled',
	task_repetition_save_scope_all: 'including all subsequent repeating tasks',
	task_repetition_save_scope_message: 'Which tasks should be saved?',
	task_repetition_save_scope_single: 'Only this task',
	task_repetition_save_scope_title: 'Save task',
	task_repetition_type_daily: 'daily',
	task_repetition_type_label: 'type',
	task_repetition_type_monthly: 'monthly',
	task_repetition_type_none: 'disabled',
	task_repetition_type_weekly: 'weekly',
	task_repetition_type_yearly: 'yearly',
	task_repetition_weekday_friday: 'Fri',
	task_repetition_weekday_monday: 'Mon',
	task_repetition_weekday_saturday: 'Sat',
	task_repetition_weekday_sunday: 'Sun',
	task_repetition_weekday_thursday: 'Thu',
	task_repetition_weekday_tuesday: 'Tue',
	task_repetition_weekday_wednesday: 'Wed',
	task_repetition_weekdays_label: 'weekdays',
	task_save_failed_notification: 'Task could not be saved',
	task_saved_notification: 'Task saved',
	task_tomorrow: 'Schedule tomorrow',
	task_tomorrow_notification: 'Task scheduled for tomorrow',
	task_version_author: 'Author',
	task_version_dialog_cancel: 'Cancel',
	task_version_dialog_confirm_cancel_label: 'No',
	task_version_dialog_confirm_message: 'Do you really want to delete this version?',
	task_version_dialog_confirm_ok_label: 'Yes',
	task_version_dialog_confirm_title: 'Delete task version',
	task_version_time: 'Date',
	task_version_title: 'Title',
	task_version_versions: 'Versions',
};
